<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div
        v-show="showMainList"
        class="main-content"
        type="primary"
      >
        <quotation-client-search-bar
          :filter="filter"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <template slot="operations">
            <el-button no="onView" type="primary" :disabled="!currentRow" @click="onView()">{{ $t('Pricing.View') }}</el-button>
            <el-button no="onAdd" type="primary" @click="onAdd()">{{ $t('Pricing.Add') }}</el-button>
          </template>
        </quotation-client-search-bar>
        <quotation-client-data-grid
          config-module="227101"
          :grid-options="gridOptions"
          :row-data="rowData"
        />
      </div>
      <quotation-client-popup
        v-if="quotationClientPopup.visible"
        :visible="quotationClientPopup.visible"
        :quotation-client="quotationClientPopup.price"
        @close="quotationClientPopup.visible=false"
        @callback="onQuotationClientPopupClose"
      />
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import QuotationClientSearchBar from '@/views/cargo/v0/Price/components/query/quotationClientSearchBar'
import QuotationClientDataGrid from '@/views/cargo/v0/Price/QuotationClient/components/quotationClientDataGrid'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { queryQuotationClient } from '@/api/sales/quotationClient'
import StrUtils from '@/utils/StrUtils'
import QuotationClientPopup from '@/views/cargo/v0/Price/components/quotationClientPopup'

export default {
  name: 'QuotationClient',
  components: {
    QuotationClientPopup,
    QuotationClientDataGrid,
    QuotationClientSearchBar
  },
  props: {
    quotationType: { type: Number, default: 0 }
  },
  data() {
    return {
      URL,
      rowData: [],
      currentRow: null,
      quotationTypeLocal: 0,
      filter: {
        name: '',
        ownerId: 0
      },
      proxy: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      quotationClientPopup: {
        visible: false,
        isDangerous: false,
        level: 99,
        etdDate: '',
        price: null,
        priceAddon: null
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      let clazz = ''
      switch (this.quotationType) {
        case 0:
          clazz = 'PriceFcl'
          break
        case 1:
          clazz = 'PriceAir'
          break
        case 2:
          clazz = 'PriceLcl'
          break
        default:
          clazz = 'PriceFcl'
          break
      }
      this.quotationTypeLocal = MultiCompanyUtil.getInstance().isAdminOrHQ2(clazz)
    },
    loadingEnd() {
      this.currentRow = null
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
    },
    handleQueryData(res) {
      this.loadingEnd()
      const result = res.data
      if (!result && result.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      // 只返回部分结果的话，弹窗提醒是否加载更多
      let isMore = false
      const count = result.length
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
        isMore = true
      }
      if (isMore) {
        result.pop()
      }
      this.rowData = result
    },
    async toAdvancedQuery(data) {
      this.proxy = data
      if (!data['ownerId']) {
        if (!this.$store.getters.isAdmin) {
          const salesUtil = await SalesUtil.getInstance()
          this.proxy['ownerIds'] = salesUtil.juniorSales
        }
      }
      this.proxy['quotationType'] = this.quotationTypeLocal
      // 当前界面没有分页组件，所以分页参数需要传false
      this.proxy['isLimited'] = false
      this.fullscreenLoading = getLoading()
      queryQuotationClient({ condition: this.proxy }).then((res) => {
        if (res && res.data && res.data.length > 0) {
          res.data = res.data.filter(p => p.branchId === 1 || p.branchId === this.$store.getters.currentOfficeId)
        }
        this.handleQueryData(res)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onQuotationClientPopupClose(isNew, data) {
      this.quotationClientPopup.visible = false
      if (isNew) {
        this.rowData.unshift(data)
      } else {
        this.currentRow = data
        this.gridOptions.api.forEachNode(node => {
          if (node.data.uuid === data.uuid) {
            node.data = data
          }
        })
        this.gridOptions.api.refreshCells({ force: true })
        this.gridOptions.api.clearFocusedCell()
      }
    },
    onRowDoubleClicked(e) {
      const data = e.data
      this.currentRow = data
      this.quotationClientPopup.price = data
      this.quotationClientPopup.visible = true
    },
    onAdd() {
      this.quotationClientPopup.price = {
        ownerId: this.$store.getters.userId
      }
      this.quotationClientPopup.visible = true
    },
    onView() {
      this.quotationClientPopup.price = this.currentRow
      this.quotationClientPopup.visible = true
    },
    onRowClicked(event) {
      this.currentRow = event.data
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

